'use client';
import { rem } from '@s7/styles';

const TransitionPresets = {
    fade: {
        in: {
            opacity: 1
        },
        out: {
            opacity: 0
        },
        transitionProperty: 'opacity'
    },
    scale: {
        in: {
            opacity: 1,
            transform: 'scale(0.96)'
        },
        out: {
            opacity: 0,
            transform: 'scale(1)'
        },
        common: {
            transformOrigin: 'top'
        },
        transitionProperty: 'transform, opacity'
    },
    pop: {
        in: {
            opacity: 1,
            transform: 'scale(1)'
        },
        out: {
            opacity: 0,
            transform: `scale(.95) translateY(${rem(8)})`
        },
        transitionProperty: 'transform, opacity',
        common: {
            transformOrigin: 'center center'
        }
    },
    'slide-down': {
        in: {
            opacity: 1,
            transform: 'translateY(0)'
        },
        out: {
            opacity: 0,
            transform: `translateY(-${rem(4)})`
        },
        common: {
            transformOrigin: 'top'
        },
        transitionProperty: 'transform, opacity'
    },
    'slide-up': {
        in: {
            opacity: 1,
            transform: 'translateY(0)'
        },
        out: {
            opacity: 0,
            transform: `translateY(${rem(4)})`
        },
        common: {
            transformOrigin: 'bottom'
        },
        transitionProperty: 'transform, opacity'
    },
    'slide-left': {
        in: {
            opacity: 1,
            transform: 'translateX(0)'
        },
        out: {
            opacity: 0,
            transform: `translateX(${rem(4)})`
        },
        common: {
            transformOrigin: 'left'
        },
        transitionProperty: 'transform, opacity'
    },
    'slide-right': {
        in: {
            opacity: 1,
            transform: 'translateX(0)'
        },
        out: {
            opacity: 0,
            transform: `translateX(-${rem(4)})`
        },
        common: {
            transformOrigin: 'right'
        },
        transitionProperty: 'transform, opacity'
    }
};

export { TransitionPresets };
//# sourceMappingURL=presets.js.map
